<!-- Author: Venkata shyam @Date: 05/06/2025  -->
<div class="popup marginBottomStyle" 
    >
    <!-- style="position: relative; overflow: scroll; height: 100%;overflow-x: hidden;" -->
    <div style="text-align: center; font-size: 22px; font-weight: bold; margin-bottom: 10px;">
      Upload Template File
  </div>
  <span class="example-spacer"></span>
  <button *ngIf= "templateFile" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"   [title]="'Download Template for ' + (data?.edata || '')" (click) = "downloadXLSX()" [style.background-color]="backgroundColorButton">Template
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon"[title]="'Download Template for ' + (data?.edata || '')"></em>
                  </button>

                  <span class="example-spacer"></span>
                  <input  type="file" #fileInput  style="display: none;" (change)="onFileChange($event)">
                  <button *ngIf="uploadFile"
                 
                   class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                           [style.background-color]="backgroundColorButton"
                           [title]="'Upload ' +  (data?.edata || '') +'_template file'"
                           (click)="fileInput.click()">
                     Upload File
          <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
          </button>
            <!-- Upload Placeholder (Shown When Grid is Not Visible) -->
<div *ngIf="!isGridVisible" class="upload-placeholder">
  <mat-icon class="upload-icon">cloud_upload</mat-icon>
  <p class="upload-text">No file uploaded yet.</p>
  <p class="upload-subtext">Click on the <strong>"Upload File"</strong> button above to import your data.</p>
</div>

  <div class="agGridOuterDiv" style="height: auto; overflow-x: auto; overflow-y: hidden;margin-bottom: 0.1%;" *ngIf="isGridVisible">
        <div>
          <mat-toolbar class="agGridtoperDiv card" style="
                  background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;">
  
                      <label i18n="@@spmsUserReg" class="textColour">Objects</label>
                      
                      <span class="example-spacer"></span>
                      <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                      </button> -->
                      <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Create Snapshot"   (click)="openSaveForm()">Create Snapshot
                      </button>
                      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                        <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                </button> -->
                  <div class="insertPageNoDiv">
                      <mat-form-field appearance="outline">
                          <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onSearchChange($event.target.value)">
                      </mat-form-field>
                  </div>
  
                  <div class="selectRecordsDiv" style="width:9.5%">
                      <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                          <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                          </mat-select>
  
                      </mat-form-field>
                  </div>
                  <div class="card pagination paginationFirstButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                  </div>
                  <div class="card pagination paginationButtons btn-rounded">
                      <ul>
                          <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                  (click)="onBtPrevious()"></em></li>
                                  <li>{{currentPage}}/{{totalPages}}</li>
                          <li class="paginationliicon" style="padding:0;"><em
                                  class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                      </ul>
                  </div>
                  <div class="card pagination paginationLastButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                  </div>
                </mat-toolbar>
              </div>
        <ag-grid-angular style="height: 300px; width: 100%;" class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs"  [animateRows]="true"
        [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
        [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
        (paginationChanged)="onPaginationChanged()" [components]="components"
        (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
    </div>
     <!-- <div >
        <div>
            <button i18n="@@TMRunButton" type="button" (click)="openSaveForm()" [style.background-color]="backgroundColorButton"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">Save</button>
            </div>
            <div>
                <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="backgroundColorButton"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
        </div> -->
     
    
 </div>

 <!-- Buttons -->
<div>
    <div class="row">
      <div class="col-lg text-center">
        <div style="display: flex; justify-content: end; gap: 10px;">
          <button *ngIf="!duplicates"
            i18n="@@TMRunButton"
            type="button"
            [disabled]="!showbutton"
            (click)="openSaveForm()"
            [style.background-color]="backgroundColorButton"
            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: .3rem 1.5rem; font-size: .85rem; width: 150px;">
            Save
          </button>
  
          <button
            i18n="@@TMRunButton"
            type="button"
            (click)="cancel()"
            [style.border-color]="backgroundColorButton"
            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px;">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  